import React, { useEffect, useState } from 'react';
import { useClickStore } from '../store/clickStore';
import { useShallow } from 'zustand/react/shallow';
import { HexColorPicker } from 'react-colorful';
import DraggablePanel from '../components/ui/DraggablePanel';

function toPickerHex(material) {
  if (!material?.color) return '#ff08ff';
  const hex = material.color.getHexString();
  return hex.startsWith('#') ? hex : `#${hex}`;
}

export default function ColorChange() {
  const [color, setColor] = useState('#ff08ff');

  const { colorMaterial, clickType } = useClickStore(
    useShallow((state) => ({
      colorMaterial: state.colorMaterial,
      clickType: state.clickType,
    }))
  );

  // Sync picker FROM the selected object — do not write back here
  useEffect(() => {
    if (colorMaterial) {
      setColor(toPickerHex(colorMaterial));
    }
  }, [colorMaterial]);

  const handleChange = (next) => {
    setColor(next);
    if (colorMaterial?.color) {
      colorMaterial.color.set(next);
      colorMaterial.needsUpdate = true;
    }
  };

  if (clickType !== 'color' || !colorMaterial) return null;

  return (
    <DraggablePanel
      id="object-color"
      handleLabel="Colour"
      zIndex={1260}
      className="pointer-events-auto"
    >
      <div className="rounded-b-md border border-yellow-600/35 border-t-0 bg-black/95 p-2 shadow-lg overflow-hidden">
        <HexColorPicker color={color.startsWith('#') ? color : `#${color}`} onChange={handleChange} />
      </div>
    </DraggablePanel>
  );
}
